Button = require 'components/common/button'
Select = require 'components/common/select_custom'
Translation = require 'components/mixins/translation'
{ string, object, autoSuggest, func, bool, array, number } = PropTypes

styles =
  suggestions:
    position: 'absolute'
    left: 0
    width: '100%'
    maxHeight: '200px'
    textAlign: 'left'
    overflowY: 'auto'
    border: '1px solid #cecece'
    zIndex: 111
    backgroundColor: 'white'

ACTION_KEYS =
  ENTER: 13
  ESCAPE: 27

SearchResults = createReactClass
  displayName: 'SuggestionsContainer'

  componentDidMount: ->
    { height: parentHeight } = @suggestionsNode.parentNode.getBoundingClientRect()
    @suggestionsNode.style.top = "#{parentHeight}px"

  render: ->
    searchResultsStyle = _.extend {}, styles.suggestions, @props.searchResultsStyle

    <div ref={(el) => @suggestionsNode = el} style={searchResultsStyle}>
      {@props.results.map (suggestion, idx) ->
        <div key={idx}>{suggestion}</div>
      }
    </div>

SearchBarComponent = createReactClass
  displayName: 'SearchBarComponent'

  propTypes:
    autoFocus: bool
    containerClass: string
    searchResultsStyle: object
    searchOnChange: bool
    searchDebounceInterval: number
    searchText: string
    searchResults: array
    searchFilters: array
    activeSearchFilter: string
    onSearchFilterChange: func
    onSearchReset: func
    onSearch: func.isRequired
    disabled: bool
    lowerCaseSearchText: bool

  mixins: [
    Translation('')
  ]

  getDefaultProps: ->
    autoFocus: true
    disabled: false
    lowerCaseSearchText: true
    searchLabel: $.t 'nav.search'
    searchDebounceInterval: 300

  getInitialState: ->
    searchText: @props.searchText

  resetSearch: ->
    @cancelDebouncedSearch()
    @abortCurrentSearch()
    @setState searchText: ''
    @props.onSearchReset?()

  canSearch: ->
    not _.isEmpty @state.searchText

  onKeyDown: (ev) ->
    key = ev.which or ev.keyCode
    switch key
      when ACTION_KEYS.ESCAPE
        @resetSearch()
      when ACTION_KEYS.ENTER
        @submitSearch()

  onChange: (evt) ->
    @setState searchText: evt.target.value, =>
      @debouncedSearch() if @props.searchOnChange

  debouncedSearch: ->
    @_debouncedSearch ?= _.debounce @doSearch, @props.searchDebounceInterval
    @_debouncedSearch()

  cancelDebouncedSearch: ->
    @_debouncedSearch?.cancel()

  submitSearch: ->
    @cancelDebouncedSearch()
    @doSearch()

  abortCurrentSearch: ->
    @searchAbortController?.abort()
    @searchAbortController = null

  getSearchOptions: ->
    return {} unless typeof AbortController is 'function'

    @abortCurrentSearch()
    @searchAbortController = new AbortController()
    signal: @searchAbortController.signal

  doSearch: ->
    return @resetSearch() unless @canSearch()
    searchText = @state.searchText.trim()
    searchText = searchText.toLowerCase() if @props.lowerCaseSearchText
    options = @getSearchOptions()

    if @props.activeSearchFilter?
      payload =
        filter: @props.activeSearchFilter
        searchText: searchText
      @props.onSearch payload, options
    else
      @props.onSearch searchText, options

  componentDidMount: ->
    @input.focus() if @props.autoFocus

  componentWillUnmount: ->
    @cancelDebouncedSearch()
    @abortCurrentSearch()

  render: ->
    { containerClass, searchResultsStyle } = @props
    canSearch = @canSearch()
    containerCls = classNames 'search-container', containerClass,
      'with-search-filter': @props.searchFilters?
    clearBtnClass = classNames 'clear-search', visible: canSearch

    <div className={containerCls}>
      {if @props.searchFilters?
        <Select
          options={@props.searchFilters}
          selected={@props.activeSearchFilter}
          onChange={@props.onSearchFilterChange}
        />
      }
      <div className='input-container'>
        <input
          ref={(el) => @input = el}
          type='text'
          placeholder={@i18n 'nav.search'}
          onChange={@onChange}
          onKeyDown={@onKeyDown}
          value={@state.searchText}
          readOnly={@props.disabled}
        />
        <Button
          className={clearBtnClass}
          onClick={@resetSearch}
          title={@i18n 'actions.cancel_search'}
        />
      </div>
      <button
        className='search'
        onClick={@submitSearch}
        style={styles.button}
        disabled={@props.disabled}
      />
      {unless _.isEmpty @props.searchResults
        <SearchResults results={@props.searchResults} searchResultsStyle={searchResultsStyle} />
      }
    </div>

module.exports = SearchBarComponent
